export const MENTIONS_REGEXP = /@<([^>]+?)>\[([^\]]+?)\]/g;

export const mentionifyHtml = (str: string) =>
  str.replaceAll(
    MENTIONS_REGEXP,
    (e) =>
      `<span class="text-primary-500 font-bold">${
        [...e.matchAll(MENTIONS_REGEXP)][0][2]
      }</span>`
  );

export const convertTextWithMentionsToPlainText = (textWithMentions: string) =>
  textWithMentions.replace(
    MENTIONS_REGEXP,
    (_match, _userId, username) => `@${username}`
  );
